export default {"src":"/_next/static/media/Czech Republic.09af6a22.svg","height":15,"width":20,"blurWidth":0,"blurHeight":0};